module.exports = "<li ng-class=\"{'gw-active': active, disabled: disabled}\">\r\n    <a ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\r\n</li>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/tabs/templates/tab-template.html
// module id = 595
// module chunks = 0